





















































import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { useConfig } from '~/composables';
import { TRACKINGS_ATTRIBUTE_SETS_CATEGORYWARE } from '~/utils/constants/product';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { productContactTrack, productGoToSiteTrack } from '~/helpers/trackings/24orepro/products';
import HTMLContent from '~/components/solepro/HTMLContent.vue';

export default defineComponent({
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>
        }
    },
    components:{
        HTMLContent
    },
    setup(props) {
        const { product } = props;
        const { config: storeConfig } = useConfig();

        const trackProductContact = (callback) => productContactTrack(props.product, callback);
        const trackGoToSite = (callback) => productGoToSiteTrack(props.product, callback);

        return {
            isSoftware: TRACKINGS_ATTRIBUTE_SETS_CATEGORYWARE[product?.attributeSetName.toLowerCase()] == TRACKINGS_ATTRIBUTE_SETS_CATEGORYWARE['software'],
            email: storeConfig.value.general_contact_email,
            phoneExtended: storeConfig.value.general_contact_phone,
            phone: (storeConfig.value.general_contact_phone || '').replace(/ /g, ''),
            trackProductContact,
            trackGoToSite
        }
    },
    methods: {
        goToForm() {
            window.open(this.product.agentFormLink)
        },
        goToSite() {
            window.open(this.product.productSite)
        },
        goToEmail() {
            window.location.href = `mailto:${this.email}`;
        }
    }
})
